export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7349.cc132f2d.jpg";